import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { FormBuilder, FormGroup, FormArray, Validators } from '@angular/forms';
import { RoleplayService, StepperContent } from '../../../service/roleplay/roleplay.service';
import { Subscription } from 'rxjs';
import { ChatService } from '../../../service/chat-service';
import { BodyColorService } from '../../../service/bodyColor/bodycolor.service';
import { ToastrService } from 'ngx-toastr';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmationDialogComponent } from '../../confirmation-dialog/confirmation-dialog.component';

@Component({
    selector: 'app-roleplay-step4',
    templateUrl: './roleplay-step4.component.html',
    styleUrl: '../../../../assets/css/roleplay.scss',
    standalone: false
})
export class RoleplayStep4Component {
  step4Form: FormGroup;
  sharedData: any = {};
  subscription: Subscription;
  profileSubscription: any = new Subscription();
  color: string = '#e8e6e3';
  inputValue: string;
  isPopupVisible: boolean = false;
  data: any = [];
  isEditMode: boolean;
  getData: any = {};
  scenario_name: string = "";

  constructor(public Router: Router, private fb: FormBuilder, private sharedService: RoleplayService,
    public ChatService: ChatService, private toastrService: ToastrService, private dialog: MatDialog) {
  }

  ngOnInit(): void {
    this.sharedService.editMode$.subscribe(mode => {
      this.isEditMode = mode;
    });

    this.step4Form = this.fb.group({
      emotionalState: this.fb.array([]),
      attitude: this.fb.array([]),
      communicationStyle: this.fb.array([]),
      emotionalInputs: this.fb.array([]),
      attitudeInputs: this.fb.array([]),
      styleInputs: this.fb.array([])
    });
    if (this.isEditMode) {
      this.sharedService.data$.subscribe({
        next: data => {
          this.data = data;
          const updatedEmotionalData = this.filterOutData(this.data, 'comm_style_emotional_state')
          const updatedAttitudeData = this.filterOutData(this.data, 'comm_style_attitude')
          const updatedStyleData = this.filterOutData(this.data, 'comm_style')
          this.scenario_name = this.data[0].scenario_name;
          const PreviousEmotionalData = this.ifPreviousSelectedMetaData('comm_style_emotional_state');
          const PreviousAttitudeData = this.ifPreviousSelectedMetaData('comm_style_attitude');
          const PreviousStyleData = this.ifPreviousSelectedMetaData('comm_style');

          if (this.sharedService.rolePlayScenarioData.step4) {
            this.setCommunicationData(PreviousEmotionalData, PreviousAttitudeData, PreviousStyleData);
          } else {
            this.setCommunicationData(updatedEmotionalData, updatedAttitudeData, updatedStyleData);
          }
        },
        error: error => console.error('Error receiving data', error),
        complete: () => console.log('Data stream completed')
      });
    } else {

      this.subscription = this.sharedService.data$$.subscribe(response => {
        const PreviousEmotionalData = this.ifPreviousSelectedMetaData('comm_style_emotional_state');
        const PreviousAttitudeData = this.ifPreviousSelectedMetaData('comm_style_attitude');
        const PreviousStyleData = this.ifPreviousSelectedMetaData('comm_style');

        if (this.sharedService.rolePlayScenarioData.step4) {
          this.setCommunicationData(PreviousEmotionalData, PreviousAttitudeData, PreviousStyleData);
        } else {
          this.setCommunicationData(response['comm_style_emotional_state'], response['comm_style_attitude'], response['comm_style']);
        }

      }
      );
    }
    // this.bodyColorService.setBodyColor(this.color);
  }

  filterOutData(data, value) {
    return data[0].meta_data.filter(item => item.roleplay_metadata_type === value).map(items => {
      const { roleplay_metadata_val: name, id } = items;
      return { name, id }
    });
  }

  groupByMetadataType() {
    return this.data[0].meta_data.reduce((acc, item) => {
      const { roleplay_metadata_type } = item;
      if (!acc[roleplay_metadata_type]) {
        acc[roleplay_metadata_type] = [];
      }
      const { id, roleplay_metadata_val: name } = item;
      acc[roleplay_metadata_type].push({ id, name });
      return acc;
    }, {});
  }

  ifPreviousSelectedMetaData(metadata) {
    if (this.sharedService.rolePlayScenarioData.roleplay_metadata.length) {
      const metaDataArray = this.sharedService.rolePlayScenarioData.roleplay_metadata;
      const objectiveMetaDataArray = metaDataArray.filter(data => {
        return data.type_name === metadata;
      });
      const updatedData = objectiveMetaDataArray.map(item => {
        const { type_value } = item;
        return { name: type_value };
      });
      return updatedData;
    }
    return [];
  }

  get emotionalState(): FormArray {
    return this.step4Form.get('emotionalState') as FormArray;
  }

  get attitude(): FormArray {
    return this.step4Form.get('attitude') as FormArray;
  }

  get communicationStyle(): FormArray {
    return this.step4Form.get('communicationStyle') as FormArray;
  }
  get emotionalInputs() {
    return this.step4Form.get('emotionalInputs') as FormArray;
  }

  get attitudeInputs() {
    return this.step4Form.get('attitudeInputs') as FormArray;
  }

  get styleInputs() {
    return this.step4Form.get('styleInputs') as FormArray;
  }

  addValueInput(type) {
    switch (type) {
      case 'E':
        this.emotionalState.push(this.fb.control(''));
        break;
      case 'A':
        this.attitude.push(this.fb.control(''));
        break;
      case 'C':
        this.communicationStyle.push(this.fb.control(''));
        break;
    }
  }

  removeInput(index: number, type: string): void {
    switch (type) {
      case 'E':
        this.emotionalState.removeAt(index);
        break;
      case 'A':
        this.attitude.removeAt(index);
        break;
      case 'C':
        this.communicationStyle.removeAt(index);
        break;
    }
  }

  setCommunicationData(emotionalState: any[], attitude: any[], communicationStyle: any[]): void {
    this.fb.array(emotionalState.map(() => this.fb.control(false)));
    this.fb.array(attitude.map(() => this.fb.control(false)));
    this.fb.array(communicationStyle.map(() => this.fb.control(false)));

    const emotionalStateFGs = emotionalState.map(values => this.fb.control(values.name));
    const emotionalStateFormArray = this.fb.array(emotionalStateFGs);
    this.step4Form.setControl('emotionalState', emotionalStateFormArray);

    const attitudeFGs = attitude.map(values => this.fb.control(values.name));
    const attitudeFormArray = this.fb.array(attitudeFGs);
    this.step4Form.setControl('attitude', attitudeFormArray);

    const communicationStyleFGs = communicationStyle.map(values => this.fb.control(values.name));
    const communicationStyleFormArray = this.fb.array(communicationStyleFGs);
    this.step4Form.setControl('communicationStyle', communicationStyleFormArray);
  }

  updateSelected(optionIndex: number, optionId: string, event: Event, type: string) {
    switch (type) {
      case 'E':
        this.updateSelectedSection(optionIndex, optionId, event, this.emotionalState, 'emotionalState');
        break;
      case 'A':
        this.updateSelectedSection(optionIndex, optionId, event, this.attitude, 'attitude');
        break;
      case 'C':
        this.updateSelectedSection(optionIndex, optionId, event, this.communicationStyle, 'communicationStyle');
        break;
    }

  }
  updateSelectedSection(optionIndex: number, optionId: string, event: Event, sectionArray: any, formControlName: string) {
    sectionArray.forEach((x, i) => {
      if (i == optionIndex) {
        if (x['checked']) {
          delete x['checked']
        } else {
          x['checked'] = true;
        }
      }
    })
  }

  retainSelectedMetaData() {

    this.sharedService.rolePlayScenarioData.roleplay_metadata =
      this.sharedService.rolePlayScenarioData.roleplay_metadata.filter(item =>
        item.type_name !== 'comm_style_emotional_state' &&
        item.type_name !== 'comm_style_attitude' &&
        item.type_name !== 'comm_style');

    let emoState = this.step4Form.value.emotionalState;
    if (emoState.length > 0) {
      emoState = emoState.filter(item => item?.trim());
      emoState.forEach(data => {
        this.sharedService.rolePlayScenarioData.roleplay_metadata.push(
          {
            type_name: "comm_style_emotional_state",
            type_value: data
          }
        )
      })
    }
    let att = this.step4Form.value.attitude;
    if (att.length > 0) {
      att = att.filter(item => item?.trim());
      att.forEach(data => {
        this.sharedService.rolePlayScenarioData.roleplay_metadata.push(
          {
            type_name: "comm_style_attitude",
            type_value: data
          }
        )
      })
    }
    let commStyle = this.step4Form.value.communicationStyle;
    if (commStyle.length > 0) {
      commStyle = commStyle.filter(item => item?.trim());
      commStyle.forEach(data => {
        this.sharedService.rolePlayScenarioData.roleplay_metadata.push(
          {
            type_name: "comm_style",
            type_value: data
          }
        )
      })
    }
    this.sharedService.rolePlayScenarioData.step4 = true;
  }

  goToStep(id: number) {
    const stepper_data: StepperContent = this.sharedService.stepperContent.find(stepper => stepper.stepId == id);
    this.changeStepper(stepper_data);
  }

  changeStepper(stepper_data: StepperContent) {
    console.log('Step4 : changeStepper: ', stepper_data);
    const current_step_id = 4;
    if (this.step4Form.valid || stepper_data.stepId < current_step_id) {
      this.retainSelectedMetaData();
      this.sharedService.changeStep(stepper_data);
    } else {
      this.toastrService.error('Invalid Form')
    }
  }
  goBack() {
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      width: '350px',
      data: { message: 'You will lose all changes. Do you really want to leave?' }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (!result) {
        return;
      }
      this.Router.navigate(['/app-trainee-dasboard'], { skipLocationChange: true });
    });
  }
}
